export default __webpack_public_path__ + "static/media/BloodMobile.8c3f3e30.jpg";